import type { FC } from 'react';

import { Alert, IconButton } from '@mui/joy';

import { type AvailableAccessKeyInstance } from '@/types/trpc/accessKeys';

import { AccessKeyIcon, CancelIcon } from '@/shared/icons/Icons';

type Props = {
  keys: AvailableAccessKeyInstance[];
  onRemove: (accessKeyInstanceId: string) => void;
};

const AccessKeyActionSelectedInstancesAlertList: FC<Props> = ({ keys, onRemove }) => {
  if (keys.length === 0) return null;

  return (
    <div className="flex max-h-64 flex-col gap-2 overflow-y-auto">
      {keys.map((accessKey) => (
        <Alert
          key={accessKey.accessKeyInstanceId}
          color="primary"
          variant="soft"
          startDecorator={<AccessKeyIcon />}
          endDecorator={
            <IconButton
              className="rounded-full"
              variant="plain"
              color="neutral"
              onClick={() => onRemove(accessKey.accessKeyInstanceId)}
            >
              <CancelIcon />
            </IconButton>
          }
        >
          {accessKey.accessKeyDescription} ({accessKey.code})
        </Alert>
      ))}
    </div>
  );
};

export default AccessKeyActionSelectedInstancesAlertList;
